import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    channels
  },
} = config

const getList = (key = '', hub = '') =>
  axios.get(channels.getList.replace(':key', key).replace(':hub', hub), {
    headers: getHeaders(true),
    //params: { ...paramsQuery },
  })

const getById = (id) =>
  axios.get(channels.getById.replace(':channelId', id), {
    headers: getHeaders(true)
  })

const deleteById = (id) =>
  axios.delete(channels.deleteById.replace(':channelId', id), {
    headers: getHeaders(true)
  })

const getSchema = (key, hub) =>
  axios.get(channels.getSchema.replace(':key', key).replace(':hub', hub), {
    headers: getHeaders(true)
  })

const publishApp = (id) =>
  axios.post(channels.publishApp.replace(':channelId', id), {}, {
    headers: getHeaders(true)
  })

const activate = (id, isEnabled ) =>
  axios.post(
    channels.activate.replace(':channelId', id),
    { isEnabled: isEnabled },
    { headers: getHeaders(true) }
  )

/**
 * Verify Whatsapp Channel
 * @param {object} config
 * @param {string} config.wabaId
 * @param {string} config.botId
 * @param {string} config.appId
 * @param {string} config.systemUserAccessToken
 * @param {string} config.credential
 * @returns
 */
const verifyWhatsappChannel = (config) =>
  axios.post(
    channels.verifyWhatsappChannel,
    { ...config },
    { headers: getHeaders(true) }
  )

/**
 * Verify Code Request
 * @param {object} config
 * @param {string} config.method
 * @param {object} config.credential
 * @returns
 */
const whatsappCodeRequest = (config) =>
  axios.post(
    channels.getCodeRequestMethod,
    { ...config },
    { headers: getHeaders(true) }
  )

/**
 * Verify Code
 * @param {object} config
 * @param {string} config.code
 * @param {object} config.credential
 * @returns
 */
const verifyWhatsappCode = (config) =>
  axios.post(
    channels.verifyWhatsappCode,
    { ...config },
    { headers: getHeaders(true) }
  )

/**
 * Verify IMAP
 * @param {object} config
 * @param {object} config.imap
 * @param {string} config.imap.host
 * @param {string} config.imap.user
 * @param {string} config.imap.password
 * @param {string} config.imap.port
 * @param {boolean} config.imap.tls
 * @param {object} config.smtp
 * @param {string} config.smtp.host
 * @param {string} config.smtp.user
 * @param {string} config.smtp.password
 * @param {string} config.smtp.port
 * @param {boolean} config.smtp.tls
 * @param {object} config.autoconfig
 * @param {string} config.autoconfig.user
 * @param {string} config.autoconfig.password
 * @returns
 */
const imapVerification = (config) =>
  axios.post(
    channels.imapVerification,
    { ...config },
    { headers: getHeaders(true) }
  )

const uriError = (data) => axios({
  method: 'post',
  url: channels.error,
  data,
  headers: getHeaders(true)
})

const getChannelsToRedirect = () => axios({
  method: 'get',
  url: channels.getChannelsToRedirect,
  headers: getHeaders(true)
})

export default {
  getList,
  getById,
  deleteById,
  getSchema,
  publishApp,
  activate,
  verifyWhatsappChannel,
  whatsappCodeRequest,
  verifyWhatsappCode,
  imapVerification,
  uriError,
  getChannelsToRedirect,
}
